// Google Analytics event tracking utilities

declare global {
  interface Window {
    gtag?: (...args: any[]) => void
  }
}

// Check if Google Analytics is available
const isGAAvailable = (): boolean => {
  return typeof window !== 'undefined' && typeof window.gtag === 'function'
}

// Track first interaction with the game (first character typed)
export const trackFirstInteraction = () => {
  if (!isGAAvailable()) return

  window.gtag!('event', 'first_interaction', {
    event_category: 'engagement',
    event_label: 'First character typed',
  })
}

// Track first successful turn (valid word entered)
export const trackFirstSuccessfulTurn = (guessNumber: number) => {
  if (!isGAAvailable()) return

  window.gtag!('event', 'first_successful_turn', {
    event_category: 'engagement',
    event_label: 'Valid word entered',
    value: guessNumber,
  })
}

// Track game finish
export const trackGameFinish = (
  result: 'win' | 'loss',
  numberOfTurns: number
) => {
  if (!isGAAvailable()) return

  window.gtag!('event', 'game_finish', {
    event_category: 'game_completion',
    event_label: result,
    value: numberOfTurns,
  })

  // Also track as a more specific event
  if (result === 'win') {
    window.gtag!('event', 'game_won', {
      event_category: 'game_completion',
      event_label: `Won in ${numberOfTurns} ${
        numberOfTurns === 1 ? 'turn' : 'turns'
      }`,
      value: numberOfTurns,
    })
  } else {
    window.gtag!('event', 'game_lost', {
      event_category: 'game_completion',
      event_label: 'Lost after maximum turns',
      value: numberOfTurns,
    })
  }
}

// Track general page views (optional - already tracked by default config)
export const trackPageView = (path: string) => {
  if (!isGAAvailable()) return

  window.gtag!('event', 'page_view', {
    page_path: path,
  })
}
